export default (params = {}) => ({
  url: "",
  title: params.title || "",
  summary: params.summary || "",
  showCopiedMessage: false,

  init() {
    // Get current page URL
    this.url = window.location.href;
  },

  shareLinkedIn() {
    const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.url)}`;
    window.open(shareUrl, "_blank", "width=600,height=600");
  },

  shareFacebook() {
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.url)}`;
    window.open(shareUrl, "_blank", "width=600,height=600");
  },

  async shareInstagram() {
    // Instagram doesn't have a direct share URL, so we'll copy the link
    // and show a message to paste it in Instagram
    if (await this.copyToClipboard()) {
      alert("Link copied! Open Instagram and paste it in your story or bio.");
    }
  },

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.url);

      // Show copied message
      this.showCopiedMessage = true;

      // Hide message after 3 seconds
      setTimeout(() => {
        this.showCopiedMessage = false;
      }, 3000);

      return true;
    } catch (err) {
      console.error("Failed to copy:", err);
      return false;
    }
  },
});
